import { ToolbarPlugin } from "@/features/notes/components/Editor/plugins/ToolbarPlugin";
import clsx from "clsx";

interface EditorFooterProps {
  onSetIsLinkEditMode: (isLinkEditMode: boolean) => void;
}

export function EditorFooter({ onSetIsLinkEditMode }: EditorFooterProps) {
  return (
    <div className={clsx("flex items-center justify-center overflow-hidden")}>
      <ToolbarPlugin onSetIsLinkEditMode={onSetIsLinkEditMode} />
    </div>
  );
}
